import React from "react";

export interface IRoute {
  path: string;
  element: React.ReactElement;
}

export enum UIRoutes {
  ACCOUNT = "account",
  INDICES = "indices/:ticker/:id",
  CRYPTO_NEWS = "news",
  EDUCATION = "education",
  CRYPTO_MARKETS = "crypto-markets",
  FEAR_AND_GREED_INDEX = "fear-and-greed",
  BLOG = "blog",
  VIEW_BLOG_BASE = "blog/article",
  VIEW_BLOG = "blog/article/:name/:id",
  LOGIN = "login",
  FORGOT_PASSWORD = "forgot-password",
  RESTORE_PASSWORD = "restore-password/:code",
  VIEW_NEWS_BASE = "news/article",
  VIEW_NEWS = "news/article/:name/:id",
  VIEW_INSTRUMENT_BASE = "instrument",
  VIEW_INSTRUMENT = "instrument/:name/:id",
  VIEW_PAGE_BASE = "pages",
  VIEW_PAGE = "pages/:name/:id",
  HOME_CHANGE_LOG = "home/changeLogs",
}

export enum PrivateUIRoutes {
  CONTROL_PANEL = "controlpanel",
  DASHBOARD = "dashboard",
  ENGINE_APP = "engine",

  USERS = "users",
  VIEW_USER_BASE = "user/edit",
  VIEW_USER = "user/edit/:id",
  CREATE_USER = "user/create",

  INSTRUMENTS = "instruments",
  VIEW_INSTRUMENT_BASE = "instrument/edit",
  VIEW_INSTRUMENT = "instrument/edit/:id",
  CREATE_INSTRUMENT = "instrument/create",

  INDICES = "indices",
  EDIT_INDICES_BASE = "indices/edit",
  EDIT_INDICES = "indices/edit/:id",
  CREATE_INDICES = "indices/create",

  NEWS = "news",
  VIEW_NEWS_BASE = "news/edit",
  VIEW_NEWS = "news/edit/:id",
  CREATE_NEWS = "news/create",

  BLOG = "blog",
  VIEW_BLOG_BASE = "blog/edit",
  VIEW_BLOG = "blog/edit/:id",
  CREATE_BLOG = "blog/create",

  MAGIC_PAGES = "magic-page",
  CREATE_MAGIC_PAGE = "magic-page/create",
  VIEW_MAGIC_PAGE = "magic-page/:id",

  SYSTEM_SETTINGS = "system-settings",
  VIEW_SYSTEM_SETTINGS = "system-settings/:id",

  EMAIL_TEMPLATES = "email-templates",
  VIEW_EMAIL_TEMPLATES_BASE = "email-templates/edit",
  VIEW_EMAIL_TEMPLATES = "email-templates/edit/:id",

  SUBSCRIBES = "subscribes",
}
